import React from "react";
import { Tag } from "../ui";
import {
  isOrderAddressUpdated,
  isOrderCustomerDetailsUpdated,
} from "../../utils/orderCustomerDisplay";
import "./customerInfoUpdatedBadge.css";

/**
 * Visible alert when customer/delivery details were modified on an active order.
 * mode="address"  → Address column (address changed)
 * mode="customer" → Customer column (name/phone changed; not address-only)
 * mode="all"      → drawer / general (any update)
 */
export default function CustomerInfoUpdatedBadge({
  order,
  t,
  className = "",
  mode = "all",
}) {
  if (!order?.customer_info_updated) return null;

  const addressUpdated = isOrderAddressUpdated(order);
  const customerUpdated = isOrderCustomerDetailsUpdated(order);

  if (mode === "address" && !addressUpdated) return null;
  if (mode === "customer" && !customerUpdated) return null;

  const label =
    mode === "address" || (mode === "all" && addressUpdated && !customerUpdated)
      ? typeof t === "function"
        ? t("ordersPage.privacy.addressUpdatedBadge", "Address updated")
        : "Address updated"
      : typeof t === "function"
        ? t("ordersPage.privacy.detailsUpdatedBadge", "Details updated")
        : "Details updated";

  // In "all" mode when both changed, prefer showing both concepts via details label
  // unless only address — handled above.
  const allLabel =
    mode === "all" && addressUpdated && customerUpdated
      ? typeof t === "function"
        ? t("ordersPage.privacy.detailsUpdatedBadge", "Details updated")
        : "Details updated"
      : label;

  return (
    <Tag
      variant="warning"
      className={`oh-customer-info-updated-badge ${className}`.trim()}
      title={allLabel}
    >
      {allLabel}
    </Tag>
  );
}
